import React from 'react';
import { ThemeProvider, Toastr } from '@getpingback/realeza';
import CheckAuthentication from './components/CheckAuthentication/CheckAuthentication';
import Layout from './components/Layout/Layout';
import Alert from './components/Alert';
import Routes from './routes/routes';

console.log('Welcome to the Pingsole! 🏓 🏓 🏓');

function App() {
  const theme = {
    primaryColor: 'green',
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <CheckAuthentication>
          <Layout>
            <Routes />
          </Layout>
        </CheckAuthentication>
        <Alert />
        <Toastr />
      </ThemeProvider>
    </>
  );
}

export default App;
